/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimalValidationError,
  AmountDecimalValidationError$inboundSchema,
  AmountDecimalValidationError$Outbound,
  AmountDecimalValidationError$outboundSchema,
} from "./amountdecimalvalidationerror.js";

export type CreateTransferLineItemOptionValidationError = {
  name?: string | undefined;
  group?: string | undefined;
  priceModifier?: AmountDecimalValidationError | undefined;
  quantity?: string | undefined;
  imageIDs?: string | undefined;
};

/** @internal */
export const CreateTransferLineItemOptionValidationError$inboundSchema:
  z.ZodType<
    CreateTransferLineItemOptionValidationError,
    z.ZodTypeDef,
    unknown
  > = z.object({
    name: z.string().optional(),
    group: z.string().optional(),
    priceModifier: AmountDecimalValidationError$inboundSchema.optional(),
    quantity: z.string().optional(),
    imageIDs: z.string().optional(),
  });
/** @internal */
export type CreateTransferLineItemOptionValidationError$Outbound = {
  name?: string | undefined;
  group?: string | undefined;
  priceModifier?: AmountDecimalValidationError$Outbound | undefined;
  quantity?: string | undefined;
  imageIDs?: string | undefined;
};

/** @internal */
export const CreateTransferLineItemOptionValidationError$outboundSchema:
  z.ZodType<
    CreateTransferLineItemOptionValidationError$Outbound,
    z.ZodTypeDef,
    CreateTransferLineItemOptionValidationError
  > = z.object({
    name: z.string().optional(),
    group: z.string().optional(),
    priceModifier: AmountDecimalValidationError$outboundSchema.optional(),
    quantity: z.string().optional(),
    imageIDs: z.string().optional(),
  });

export function createTransferLineItemOptionValidationErrorToJSON(
  createTransferLineItemOptionValidationError:
    CreateTransferLineItemOptionValidationError,
): string {
  return JSON.stringify(
    CreateTransferLineItemOptionValidationError$outboundSchema.parse(
      createTransferLineItemOptionValidationError,
    ),
  );
}
export function createTransferLineItemOptionValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<
  CreateTransferLineItemOptionValidationError,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CreateTransferLineItemOptionValidationError$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'CreateTransferLineItemOptionValidationError' from JSON`,
  );
}
